import script from "./SupportFormAndBoxComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./SupportFormAndBoxComponent.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__